export const MAX_CVV_ATTEMPTS = 3;

export const CVV_CONTAINER_ID = 'cvv-challenge-card-container';

export const CUSTOMER_CARE_PHONE = {
    text: '1-888-839-9638',
    href: 'tel:+18888399638',
};

export const CVV_CHALLENGE_COPY = {
    cvvAlertTitle: 'Security code required',
    cvvAlertBody: (brand: string, lastFour: string) =>
        `To keep your information secure, please re-enter the security code for your default ${brand} ending in ${lastFour}.`,
    maxAttemptsAlertTitle: 'Maximum attempts reached',
    maxAttemptsAlertBody: `You've reached the maximum of ${MAX_CVV_ATTEMPTS} attempts. To keep your information secure, please re-enter your credit or debit card details.`,
    newAddressLabel: 'New shipping address',
    cvvTooltip:
        '3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front.',
    submitCta: 'Verify and update address',
    customerCare: 'If you have any questions or need help, please call customer care at',
    remainingAttempts: (remaining: number) =>
        `Security code not recognized. ${remaining} ${remaining === 1 ? 'attempt' : 'attempts'} remaining.`,
};
